/**
 * Ryzup header — CSS sticky (prototype). JS: nav toggle + layout tokens + stuck shadow.
 */
(function () {
  if (window.__ryzupHeaderInit) return;
  window.__ryzupHeaderInit = true;

  function bindNavToggle(header) {
    const toggle = header.querySelector('[data-ryzup-nav-toggle]');
    const nav = header.querySelector('.nav');
    toggle?.addEventListener('click', () => nav?.classList.toggle('is-open'));
  }

  function bindAccountDialog(header) {
    if (header.dataset.ryzupAccountDialogBound === 'true') return;
    header.dataset.ryzupAccountDialogBound = 'true';

    // Composed event, does not bubble — anchor dialog below the account button.
    document.addEventListener(
      'open',
      (event) => {
        if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;
        if (!header.contains(event.target)) return;

        const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
        event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
      },
      true,
    );
  }

  function initRyzupHeader() {
    const header = document.getElementById('site-header');
    const announcement = document.getElementById('site-announcement');
    if (!header) return false;

    const syncMetrics = () => {
      const announcementHeight = announcement?.offsetHeight ?? 0;
      const headerHeight = header.offsetHeight || 0;

      document.documentElement.style.setProperty('--ryzup-announcement-h', `${announcementHeight}px`);
      document.documentElement.style.setProperty('--header-offset', `${headerHeight}px`);
      document.documentElement.style.setProperty(
        '--ryzup-chrome-top',
        `${announcementHeight + headerHeight}px`,
      );
    };

    bindNavToggle(header);
    bindAccountDialog(header);
    syncMetrics();

    window.addEventListener('resize', syncMetrics, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(syncMetrics);
      ro.observe(header);
      if (announcement) ro.observe(announcement);
    }

    if (announcement && typeof IntersectionObserver !== 'undefined') {
      const stuckObserver = new IntersectionObserver(
        ([entry]) => {
          header.classList.toggle('is-stuck', !entry.isIntersecting);
        },
        { root: null, threshold: 0 },
      );
      stuckObserver.observe(announcement);
    }

    return true;
  }

  function boot(retriesLeft) {
    if (initRyzupHeader()) return;
    if (retriesLeft <= 0) return;
    requestAnimationFrame(() => boot(retriesLeft - 1));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(20), { once: true });
  } else {
    boot(20);
  }
})();
